/* eslint-disable functional/prefer-readonly-type */
import React, { useEffect, useState } from 'react';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { useHookstate } from '@hookstate/core';
import { getAllCategories } from './services';
import { CategoriesResponse } from './interfaces';


interface CategoriesProps {
    readonly onCategoriesChange: (value: number[]) => void;
    readonly categoriesId?: readonly number[];
    readonly disabled?: boolean
}

export default function FilterAutocompleteCategories({ onCategoriesChange, categoriesId, disabled }: CategoriesProps) {
    const { translate } = useLang();
    const [options, setOptions] = useState<readonly CategoriesResponse[]>([]);
    const [value, setValue] = useState<CategoriesResponse[] | undefined>([]);
    const loading = useHookstate(false);

    useEffect(() => {
        getAllCategories().then(categories => {
            setOptions(categories)
            setValue([])
        })
    }, [])

    useEffect(() => {
        if (!categoriesId?.length) {
            setValue([])
        }
    }, [categoriesId?.length])

    return (
        <FormControl fullWidth size='small' >
            <Autocomplete
                filterSelectedOptions
                disableCloseOnSelect
                limitTags={2}
                sx={{ height: 1 }}
                ListboxProps={{ style: { maxHeight: '15rem' } }}
                id='filter-categories'
                multiple
                options={options}
                value={value}
                disabled={disabled}
                noOptionsText={translate('No options')}
                clearText={translate('Clear')}
                size='small'
                loading={loading.get()}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option.name ?? ''}
                onChange={(_, categories) => {
                    setValue(categories)
                    onCategoriesChange(categories.map(category => category.id) ?? [])
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={translate('Categories')}
                    />
                )}
            />
        </FormControl>
    )
}